import React, { memo, ReactNode } from 'react'

import { useModal } from '@surglogs-app/prompt'
import { Box, Text, TextButton } from '@surglogs-app/ui'

import { FileType, FILE_TYPE_ALL } from '../constants'
import { SupportedFilesModal } from '../modal'
import { useTranslation } from '../services'

export interface DefaultFileInputContainerProps {
  children: ReactNode
  fileTypes?: FileType[]
}

export const DefaultFileInputContainer = memo(
  ({ children, fileTypes = FILE_TYPE_ALL }: DefaultFileInputContainerProps) => {
    const { t } = useTranslation()

    const [onClick] = useModal((props) => (
      <SupportedFilesModal {...props} {...{ fileTypes }} />
    ))

    return (
      <Box {...{ w: '100%' }}>
        <Text {...{ paragraph: true, mb: 'md' }}>
          {t('fileInstructions')}{' '}
          <TextButton {...{ onClick }}>{t('supportedFiles')}</TextButton>
        </Text>
        {children}
      </Box>
    )
  },
)
